import { EmployeeLink } from 'domain/shared/employee';
import { DATE_FORMAT, getValue } from 'framework/utils';
import { TextField } from 'framework/ui/field';
import { ProcessStarter } from 'domain/gpo/cockpit/instance/processInstanceService';
import { useShowContext } from 'framework/show';
import { ShowDate } from 'framework/ui/ui-builder';
import { Typography } from '@mui/material';

interface Props {
  startDateTimeSource?: string;
  startDateTimeValue?: string;

  processStarterSource?: string;
  processStarterValue?: ProcessStarter;
}
const ProcessStartInfoField = ({
  startDateTimeSource,
  startDateTimeValue,
  processStarterSource,
  processStarterValue,
}: Props) => {
  const { data } = useShowContext();

  const startDateTime = getValue(
    startDateTimeValue,
    (src: any) => data && data.getValueBySource(src),
    startDateTimeSource,
    '',
  );
  const processStarter = getValue(
    processStarterValue,
    (src: any) => data && data.getValueBySource(src),
    processStarterSource,
    '',
  );

  return (
    <TextField
      label={
        <Typography component="span" fontStyle="italic">
          Started
        </Typography>
      }
      value={
        <>
          <ShowDate dateUTC={startDateTime} format={DATE_FORMAT.FULL} />
          {processStarter?.name && (
            <>
              <Typography component="span"> by </Typography>
              <EmployeeLink id={processStarter.alias} name={processStarter.name} />
            </>
          )}
        </>
      }
    />
  );
};

export default ProcessStartInfoField;
